import { authDelete, authPost } from "../../../services/authMiddleware"

export const postPortfolioItem = body => {
    return authPost('/api/portfolioitem', body);
}
export const deletePortfolioItem = body => {
    return authDelete('/api/portfolioitem', body);
}